__turbopack_context__.v({
  "chevron": "article-topic-row-module-scss-module__GHA0IG__chevron",
  "count": "article-topic-row-module-scss-module__GHA0IG__count",
  "heading": "article-topic-row-module-scss-module__GHA0IG__heading",
  "row": "article-topic-row-module-scss-module__GHA0IG__row",
  "title": "article-topic-row-module-scss-module__GHA0IG__title",
});
